<template>
  <div class="scene-manage-container page-primary">
    <transition
      v-if="isStarRiver"
      enter-active-class="animate__animated animate__fadeInDown"
      leave-active-class="animate__animated animate__fadeOutUp"
      :duration="{ enter: 300, leave: 300 }">
      <div
        class="expiredTitle"
        v-if="showExpired">
        <div>
          <i class="el-icon-warning" />
          <span>
            您的账户已过期，当前场景不可查看。可前往
            <span
              class="expiredTitle-link"
              @click="getBuyOrder">
              购买套餐页
            </span>
            选择合适的套餐继续使用我们的服务。
          </span>
        </div>
        <i
          class="el-icon-close"
          @click="closeExpired" />
      </div>
    </transition>
    <div class="header">
      <div class="symbol-box">
        <icon-svg
          icon-class="ic-ico_folder1"
          size="14" />
      </div>
      <div class="name-box">{{ `场景管理 (${total})` }}</div>
    </div>
    <div class="operation-box operate-area">
      <div class="common-button-box">
        <el-button
          v-if="isChecked('Project.Single.Scene.Create')"
          class="primary-btn gr8"
          size="small"
          type="primary"
          @click="createScene">
          创建场景
        </el-button>
        <el-button
          class="normal-btn gr8"
          v-if="isChecked('Project.Single.Scene.BatchShare') && total"
          size="small"
          @click="batchShare">
          批量分享
        </el-button>
        <el-button
          class="normal-btn gr8"
          v-if="isChecked('Project.Single.Scene.BatchDelete') && total"
          size="small"
          @click="batchDelete">
          批量删除
        </el-button>
        <el-button
          class="normal-btn gr8"
          size="small"
          @click="openConvertQueueDialog"
          v-if="isAdmin()">
          转换队列
        </el-button>
      </div>
      <div class="filter-box">
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="mini"
            v-model="keywords"
            placeholder="请输入场景名称"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="search" />
          </el-input>
        </div>
        <div
          class="icon-box"
          title="切换视图"
          @click="switchMode">
          <icon-svg
            size="20"
            v-if="viewMode === 'card'"
            icon-class="icon-liebiaoshitu1" />
          <icon-svg
            size="20"
            v-if="viewMode === 'table'"
            icon-class="icon-suolvetushitu" />
        </div>
      </div>
    </div>
    <CardList
      ref="cardList"
      v-if="viewMode === 'card'"
      :isExpired="isExpired"
      :keywords="keywords"
      :updateTotal="updateTotal"
      :openShareDialog="openShareDialog"
      :openSceneNameDialog="openSceneNameDialog"
      :openSceneInfoDialog="openSceneInfoDialog"
      :openCrsDialogVisible="openCrsDialogVisible" />
    <TableList
      ref="tableList"
      v-if="viewMode === 'table'"
      :keywords="keywords"
      :updateTotal="updateTotal"
      :openShareDialog="openShareDialog"
      :openSceneNameDialog="openSceneNameDialog"
      :openSceneInfoDialog="openSceneInfoDialog" />
    <ShareDialog
      :visible="shareDialogVisible"
      resourceType="scene"
      :resourceList="shareSceneList"
      :closeDialog="closeShareDialog" />
    <SceneNameDialog
      :visible="sceneNameDialogVisible"
      :copyParams="copyParams"
      :submitModify="submitModify"
      :closeDialog="closeSceneNameDialog" />
    <SceneInfoDialog
      :visible="sceneInfoDialogVisible"
      :sceneInfo="currSceneInfo"
      :updateDataList="updateDataList"
      :closeDialog="closeSceneInfoDialog" />
    <ConvertQueueDialog
      :visible="convertQueueDialogVisible"
      :closeDialog="closeConvertQueueDialog" />
    <CrsDialog
      :visible="crsDialogVisible"
      :coordinatesInfo="coordinatesInfo"
      :closeDialog="closeCrsDialogVisible" />
  </div>
</template>

<script>
import ShareDialog from '@/components/ShareDialog.vue'
import SceneNameDialog from '@/components/SceneNameDialog.vue'

import CardList from '../sceneManage/sceneList/CardList.vue'
import TableList from '../sceneManage/sceneList/TableList.vue'
import SceneInfoDialog from '../sceneManage/sceneList/SceneInfoDialog.vue'
import ConvertQueueDialog from '../sceneManage/sceneList/ConvertQueueDialog.vue'
import CrsDialog from '../sceneManage/sceneList/CrsDialog.vue'

import { Store } from '@/utils/store'

import { copySceneService } from '@/service/interface'
import { getSubScibe } from '@/service/personInfo'

export default {
  data() {
    return {
      isStarRiver: window.isStarRiver,

      viewMode: 'card',
      keywords: '',
      total: 0,

      shareDialogVisible: false,
      shareSceneList: [],

      sceneNameDialogVisible: false,
      copyParams: {},

      sceneInfoDialogVisible: false,
      currSceneInfo: {},

      convertQueueDialogVisible: false,

      crsDialogVisible: false,
      coordinatesInfo: {},

      showExpired: false,
      isExpired: false
    }
  },
  components: {
    ShareDialog,
    SceneNameDialog,
    CardList,
    TableList,
    SceneInfoDialog,
    ConvertQueueDialog,
    CrsDialog
  },
  mounted() {
    const isDemoProj = JSON.parse(sessionStorage.getItem('isDemoProj'))
    if (!isDemoProj && window.isStarRiver) {
      this.checkIsExpired()
    }
  },
  methods: {
    async checkIsExpired() {
      const { data, isSuccess, errMsg } = await getSubScibe()
      const flag = localStorage.getItem('subInfoFlag')
      if (data.noneSubscribe) {
        if (flag !== null) {
          this.showExpired = false
        } else {
          this.showExpired = true
        }
        this.isExpired = true
        return
      }
      
      if (!data.noneSubscribe && !data.trialing && !data.subscribing) {
        if (flag !== null) {
          this.showExpired = false
        } else {
          this.showExpired = true
        }
        this.isExpired = true
      } else {
        this.isExpired = false
        this.showExpired = false
      }
    },
    getBuyOrder() {
      this.$router.push('/purchasePackage')
    },
    closeExpired() {
      this.showExpired = false
      localStorage.setItem('subInfoFlag', 'false')
    },
    createScene() {
      this.openSceneInfoDialog({})
    },
    batchShare() {
      let dom = this.$refs[`${this.viewMode}List`]
      dom.batchShare()
    },
    batchDelete() {
      let dom = this.$refs[`${this.viewMode}List`]
      dom.batchDelete()
    },
    search() {
      this.updateDataList()
    },
    switchMode() {
      this.keywords = ''

      if (this.viewMode === 'card') {
        this.viewMode = 'table'
      } else {
        this.viewMode = 'card'
      }
    },
    openShareDialog(scenes) {
      this.shareSceneList = scenes
      this.shareDialogVisible = true
    },
    closeShareDialog() {
      this.shareSceneList = []
      this.shareDialogVisible = false
    },
    openConvertQueueDialog() {
      this.convertQueueDialogVisible = true
    },
    closeConvertQueueDialog() {
      this.convertQueueDialogVisible = false
    },
    openCrsDialogVisible(sceneInfo) {
      let coordinatesInfo = {
        coordinates: sceneInfo.coordinates,
        coordinatesType: sceneInfo.coordinatesType
      }
      this.coordinatesInfo = coordinatesInfo
      this.crsDialogVisible = true
    },
    closeCrsDialogVisible() {
      this.coordinatesInfo = {}
      this.crsDialogVisible = false
    },
    openSceneNameDialog(sceneInfo) {
      let params = {
        sceneId: sceneInfo.sceneId,
        sceneName: `${sceneInfo.sceneName}-副本`
      }
      if (params.sceneName.length > 100) {
        this.copyParams = params
        this.sceneNameDialogVisible = true
      } else {
        this.copyScene(params).then(() => {
          this.copyParams = {}
        })
      }
    },
    submitModify(params) {
      return new Promise(resolve => {
        this.copyScene(params).then(() => {
          resolve()
        })
      })
    },
    closeSceneNameDialog() {
      this.sceneNameDialogVisible = false
      this.copyParams = {}
    },
    openSceneInfoDialog(sceneInfo) {
      this.currSceneInfo = sceneInfo
      this.sceneInfoDialogVisible = true
    },
    closeSceneInfoDialog() {
      this.currSceneInfo = {}
      this.sceneInfoDialogVisible = false
    },
    copyScene(params) {
      return new Promise(resolve => {
        copySceneService(params).then(response => {
          if (response.isSuccess) {
            this.keywords = ''
            this.updateDataList()
            resolve(response)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    updateDataList() {
      this.$nextTick(() => {
        if (this.viewMode === 'card') {
          this.$refs.cardList.initSceneList()
        } else {
          this.$refs.tableList.initSceneList()
        }
      })
    },
    updateTotal(total) {
      this.total = total
    },
    isAdmin() {
      if (!this.isChecked('Permission.Create')) {
        return false
      } else {
        return true
      }
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
.scene-manage-container {
  position: relative;
  margin-bottom: 16px;
  flex: 1;

  .expiredTitle {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 48px;
    background: #fff6f1;
    border-radius: 16px 16px 16px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    font-weight: 400;
    font-size: 14px;
    color: #e37318;
    margin: 0 16px;
    margin-top: 8px;
    .el-icon-warning {
      margin-right: 8px;
    }
    .el-icon-close {
      cursor: pointer;
    }
    &-link {
      font-weight: 500;
      font-size: 14px;
      color: #2580ff;
      margin: 0 8px;
      cursor: pointer;
    }

    .el-icon-close {
      color: #e37318;
      font-size: 14px;
    }
  }

  .header {
    display: flex;
    align-items: center;

    .symbol-box {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      color: var(--base-primary-bgColor);
      border-radius: 50%;
      background: var(--base-bg-light-color24);
    }

    .name-box {
      font-size: 18px;
      font-weight: 500;
      margin-left: 16px;
      color: var(--page-bread-text-color);
    }
  }

  .operation-box {
    display: flex;
    justify-content: space-between;

    .common-button-box {
      :deep(.el-button) {
        margin-left: 0;
      }
    }

    .filter-box {
      display: flex;

      .common-input-box {
        :deep(.el-input__inner) {
          height: 32px;
        }
      }

      .icon-box {
        font-size: 19px;
        margin-left: 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        transition: all 0.3s;
        color: var(--sceneCard-search-icon-color);
        &:hover {
          color: var(--base-primary-color);
        }
      }
    }
  }
}
</style>
